var chineseToPinyin = require("chinese-to-pinyin");
var utils = require('ntils');

var fixedDic = {
  '晟': 'sheng'
};

function dbs2sbc(str) {
  var result = "";
  for (var i = 0; i < str.length; i++) {
    code = str.charCodeAt(i);
    if (code >= 65281 && code <= 65373) {
      var d = str.charCodeAt(i) - 65248;
      result += String.fromCharCode(d);
    } else if (code == 12288) {
      var d = str.charCodeAt(i) - 12288 + 32;
      result += String.fromCharCode(d);
    } else {
      result += str.charAt(i);
    }
  }
  return result;
}

function pinyin(text) {
  text = dbs2sbc(String(text || ''));
  utils.each(fixedDic, function (name, value) {
    text = text.replace(new RegExp(name, 'igm'), value);
  });
  return chineseToPinyin(text, {
    noTone: true,
    filterChinese: true
  });
};

window.pinyin = pinyin;
module.exports = pinyin;


// WEBPACK FOOTER //
// ./src/scripts/components/contactForm/py.js